var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7951 21.9929H4.67766C3.01921 21.9929 1.67969 20.6534 1.67969 18.9949V2.99865C1.67969 1.89301 2.5727 1 3.67834 1H20.8086C21.9142 1 22.8073 1.89301 22.8073 2.99865V18.9879C22.8073 20.6463 21.4607 22 19.7951 22V21.9929Z",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8097 6.93921H6.67969",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8097 11H6.67969",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8097 15H6.67969",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7422 22L31.7858 4.73244L29.2899 1.00814L27.0441 4.71519L27.0005 21.9827L31.7422 22Z",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 6.5166L27.2737 6.51169",
    stroke: "#89A2B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesIcon);
export default __webpack_public_path__ + "static/media/templates_icon.f3835106d25833a1c5dc6f355ca03508.svg";
export { ForwardRef as ReactComponent };